module.exports = __webpack_public_path__ + "static/cercazone_nordest5-f0d6201b33b4edc99b00ddd7505d3c2a.jpg";